<div class="row">
  @if (showThumbnails) {
    <div class="offset-3 offset-xl-2" data-test="coll-thumbnail"></div>
  }
  <div [ngClass]="showThumbnails ? 'col-9 col-xl-10' : 'col-md-12'">
    @if (showLabel) {
      <ds-badges [object]="dso" [context]="context"></ds-badges>
    }
    @if (linkType !== linkTypes.None) {
      <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null" [routerLink]="['/collections/' + dso.id]" class="lead" [innerHTML]="dsoTitle | dsEscapeHtml"></a>
    }
    @if (linkType === linkTypes.None) {
      <span class="lead" [innerHTML]="dsoTitle | dsEscapeHtml"></span>
    }
    @if (dso.shortDescription) {
      <div class="text-muted abstract-text" [innerHTML]="firstMetadataValue('dc.description.abstract')"></div>
    }
  </div>
</div>
